const schoolRoutes = [
  {
    path: "/school/resource", name: "实践资源库", icon: "folder",
    children: [
      {
        path: "/school/resource/study", name: "学习资源",
      },
      {
        path: "/school/resource/pavilion", name: "数字展馆",
      },
      {
        path: "/school/resource/base", name: "实践基地",
      },
      {
        path: "/school/resource/question", name: "试题资源",
      },
    ]
  },
  {
    path: "/school/teach", name: "实践教学活动", icon: "appstore",
  },
  {
    path: "/school/case", name: "实践案例", icon: "cases",
    children: [
      { path: "/school/case/ledger", name: "案例台账" },
      { path: "/school/case/excellent", name: "优秀案例" }
    ]
  },
  {
    path: "/school/hsjr", name: "红色金融实践", icon: "appstore",
    children: [
      {
        path: "/school/hsjr/class", name: "实践班级",
      },
      {
        path: "/school/hsjr/stadiumType", name: "场馆类型",
      },
      {
        path: "/school/hsjr/stadiumAddress", name: "场馆旧址",
      },
    ]
  },
  {
    path: "/school/statist", name: "活动数据统计", icon: "appstore",
  },
  {
    path: "/school/system", name: "系统管理", icon: "setting",
    children: [
      {
        path: "/school/system/admin", name: "管理员管理",
      },
      {
        path: "/school/system/teacher", name: "教师管理",
      },
      {
        path: "/school/system/student", name: "学生管理",
      },
    ]
  },
]

const activityRoutes = {
  path: "/school/activity", name: "活动管理", icon: "activity",
  children: [
    {
      path: "/school/activity/manage", name: "活动管理",icon: "activity",
    },
    {
      path: "/school/activity/class", name: "班级管理",icon: "class",
    },
    {
      path: "/school/activity/progress", name: "实践进度",icon: "practice",
    },
    {
      path: "/school/activity/draw", name: "绘云馆图谱",icon: "t005", code: 'T005'
    },
    {
      path: '/school/activity/hall', name: '讲展馆故事', icon: "t005", code: 'T009'
    },
    {
      path: "/school/activity/upload", name: "传点位打卡",icon: "t006", code: 'T006'
    },
    {
      path: "/school/activity/create", name: "创实践微影",icon: "t007", code: 'T007'
    },
    {
      path: '/school/activity/report', name: '写实践报告', icon: "t007", code: 'T008'
    },
    {
      path: "/school/activity/summary", name: "实践成绩汇总",icon: "allscore", 
    },
    {
      path: "/school/activity/analytics", name: "统计分析",icon: "class", 
    },

  ]
}

export {
  schoolRoutes,
  activityRoutes
}